<template>
    <!-- modal-xl -->
    <b-modal id="certificateCheckModal" size="xl" title="Certificate Check" title-class="font-18" hide-footer>
        <div class="row row-container">
            <div class="left-pane">
                <h4 class="mb-3">{{ this.selected_searched_certificate.company_name }}</h4>
                <b-form-group label="Vat no:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input disabled v-model="selected_searched_certificate.vat_no" type="text" class="b-form-input" size="sm"></b-form-input>
                </b-form-group>
                <b-form-group label="Reg no:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input
                        disabled
                        v-model="selected_searched_certificate.company_reg"
                        type="text"
                        class="b-form-input"
                        size="sm"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Certificate No:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input
                        disabled
                        v-model="certificate_no"
                        type="text"
                        class="b-form-input"
                        size="sm"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Issue Date:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input disabled v-model="local_issue_date" type="text" class="b-form-input" size="sm"></b-form-input>
                </b-form-group>
                <b-form-group label="Expiry Date:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input disabled v-model="local_expiry_date" type="text" class="b-form-input" size="sm"></b-form-input>
                </b-form-group>

                <!-- <div class="group-of-actions">
                    <div class="mt-4 mb-3 d-flex justify-content-around">
                        <b-button @click="duplicate_certificate" variant="primary" size="sm" class="btn btn-primary button-width pt-2 pb-2"
                            >Duplicate</b-button
                        >
                    </div>
                </div> -->
                <div class="group-of-actions d-flex justify-content-center">
                    <!-- <div class="group-of-actions d-flex "> -->
                    <b-button @click="newWindow" variant="primary" type="button" class="btn btn-primary m-1 mt-2">
                        <i class="mdi mdi-dock-window mr-1"></i> View
                    </b-button>

                    <b-button @click="duplicate_certificate" variant="primary" type="button" class="btn btn-primary m-1 mt-2 float-right">
                        Use this {{ selected_searched_certificate.document_type }}
                    </b-button>
                </div>
            </div>

            <div class="right-pane">
                <!-- <embed src="example-pdf.pdf#page=1&zoom=50&toolbar=0" class="w-100 h-100" /> -->

                <embed :src="this.selectedFile" class="w-100 h-100" />
            </div>
        </div>

        <div class="modal-footer mt-3">
            <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal()">
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { adminComputed, suppliersComputed, suppliersMethods } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
    data: () => ({
        local_issue_date: "",
        local_expiry_date: "",
        certificate_no: "",
        selectedFile: ""

    }),
    computed: { ...adminComputed, ...suppliersComputed },
    methods: {
        ...suppliersMethods,
        closeModal() {
            // this.$emit("handleModal", "certificateMatchListModal");
            this.$bvModal.hide("certificateCheckModal");
        },
        duplicate_certificate() {
            Swal.fire({
                title: `Duplicate this certifiate`,
                text: `Are you sure that you would like to duplicate this certificate?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, duplicate!",
            }).then((result) => {
                if (result.value) {
                    this.duplicateClientSupplierCertificate({
                        certificate_id: this.selected_searched_certificate.id,
                        client_supplier_id: this.selected_supplier_details.id,
                        capture_user_id: this.user_id,
                        capture_user: this.username,
                    }).then(() => {
                        Swal.fire("Certificate was duplicated");

                        // this.setSelectedCertificate(this.selected_searched_certificate);

                        // ! will refresh the certificate list moal tables details for the specific supplier
                        this.setSupplierCertificates(this.selected_supplier_details.id).then(() => {
                            this.closeModal();

                            this.$bvModal.hide("certificateCheckModal");
                            this.$bvModal.hide("certificateMatchListModal");

                            this.$emit("handleModal", "certificateListModal");
                        });
                    });
                }
            });
        },
    },

    mounted() {
        //eslint-disable-next-line
        console.log("the selected searched cert", this.selected_searched_certificate);

        // changes the values in the state
        this.local_issue_date = this.selected_searched_certificate.issue_date.substring(0, 10);
        this.local_expiry_date = this.selected_searched_certificate.expiry_date.substring(0, 10);
        this.certificate_no =
                this.selected_searched_certificate.certificate_no == null ? "" : this.selected_searched_certificate.certificate_no;

        this.selectedFile = this.selected_supplier_certificate.certificate_src + "#page=1&zoom=75&toolbar=0";
    },
};
</script>

<style lang="scss" scoped>
//   the default style attached to modal footer  border-top: 1px solid #eff2f7;
.align-text-setting {
    text-align: right;
}
.height {
    min-height: 500px;
}

// this makes the left and right pane in the flex
.row-container {
    display: flex;
    padding: 10px;
}

.left-pane {
    width: 40%;

    .b-form-group {
        margin-right: 50px;
    }
    .b-form-input {
        max-width: 100%;
    }
}
.group-of-actions {
    border-top: 1px solid #eff2f7 !important;
    margin-top: 25px;
    padding-top: 15px;
    margin-right: 25px;
}

.button-width {
    width: 200px;
}

.right-pane {
    width: 60%;
    display: flex;
    flex-direction: column;
}

// the purpose of this media query is simply to make the contents of modal display flex-column
// and then for the panes to have a width off 100% instead of 50%
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
    .row-container {
        flex-direction: column;
    }

    .left-pane {
        width: 100%;
    }

    .right-pane {
        width: 100%;
        margin-top: 25px;
        height: 350px;
    }
}
</style>
